
import { Component, InjectReactive, Vue } from 'nuxt-property-decorator';
import { PresentationMedia } from 'fourwaves-shared';
import { PresentationFigures } from 'fourwaves-shared/components';

@Component({
  components: {
    PresentationFigures,
  },
})
export default class PresentationFiguresSubview extends Vue {
  @InjectReactive() presentationMedia!: PresentationMedia;

  get figures() {
    return this.presentationMedia.figures?.value || [];
  }
}
